import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";

const SightSeeingBookings = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  const getTodayDate = () => {
    const today = new Date();
    const offset = today.getTimezoneOffset();
    const localDate = new Date(today.getTime() - offset * 60 * 1000);
    return localDate.toISOString().split("T")[0];
  };

  const getFirstDayOfMonth = () => {
    const date = new Date();
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const offset = firstDay.getTimezoneOffset();
    const localDate = new Date(firstDay.getTime() - offset * 60 * 1000);
    return localDate.toISOString().split("T")[0];
  };

  const [pageLoading, setPageLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rawResponse, setRawResponse] = useState({}); 

  const [fromDate, setFromDate] = useState(getFirstDayOfMonth());
  const [toDate, setToDate] = useState(getTodayDate());
  const [bookingStatus, setBookingStatus] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [bookingNo, setBookingNo] = useState("");

  const GetData = async (pNum = 1) => {
    if (!user?.cid) return;
    setPageLoading(true);
    const queryParams = new URLSearchParams({
      customerName: customerName || "",
      bookingNo: bookingNo || "",
      bookingStatus: bookingStatus || "",
      paymentStatus: paymentStatus || "",
      fromDate: fromDate || "",
      toDate: toDate || "",
      pageNumber: pNum,
      pageSize: pageSize
    }).toString();

    try {
      const url = `${config.GETCOMPANYSIGHTSEEINGBOOKINGS}/${user?.cid}?${queryParams}`;
      const res = await apiService.post(url);
      console.log(res)
      if (res) {
        setLists(res.data || []);
        setPageNumber(res.pageNumber || 1);
        setPageSize(res.pageSize || 20);
        setTotalPages(res.totalPages || 0);
        setTotalRecords(res.totalRecords || 0);
        setRawResponse(res); 
      }
    } catch (error) {
      console.error("Failed to fetch bookings:", error);
      setLists([]);
    } finally {
      setPageLoading(false);
    }
  };

  const GetPageData = (number) => {
    setPageNumber(number);
    GetData(number);
  };

  const GetFirstPageData = () => {
    if (rawResponse.previousPage !== null) GetData(1);
  };

  const GetLastPageData = () => {
    if (rawResponse.nextPage !== null) GetData(totalPages);
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => (
    <li
      className={`page-item ${pageNumber === number ? "active" : ""}`}
      key={number}
      onClick={() => GetPageData(number)}
    >
      <Link className="page-link">{number}</Link>
    </li>
  ));

  const handleSearch = () => {
    setPageNumber(1);
    GetData(1);
  };

  const handleReset = () => {
    setFromDate(getFirstDayOfMonth());
    setToDate(getTodayDate());
    setBookingStatus("");
    setPaymentStatus("");
    setCustomerName("");
    setBookingNo("");
    setPageNumber(1);
    setTimeout(() => GetData(1), 100); 
  };

  useEffect(() => {
    if (user && !loading) {
      GetData(pageNumber);
    }
  }, [user, loading]);

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
    return null;
  }

  return (
          <div className="container-fluid mt-2">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-body">
                  <div className="row mb-4 g-3 bg-light p-3 rounded">
                    <div className="col-md-2">
                      <label className="form-label">Customer Name</label>
                      <input 
                        type="text" className="form-control" placeholder="Name..." 
                        value={customerName} onChange={(e) => setCustomerName(e.target.value)}
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Booking No</label>
                      <input 
                        type="text" className="form-control" placeholder="Ref No..." 
                        value={bookingNo} onChange={(e) => setBookingNo(e.target.value)}
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Booking Status</label>
                      <select className="form-select" value={bookingStatus} onChange={(e) => setBookingStatus(e.target.value)}>
                        <option value="">All Status</option>
                        <option value="CONFIRMED">CONFIRMED</option>
                        <option value="PENDING">PENDING</option>
                        <option value="CANCELLED">CANCELLED</option>
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Payment Status</label>
                      <select className="form-select" value={paymentStatus} onChange={(e) => setPaymentStatus(e.target.value)}>
                        <option value="">All Payment</option>
                        <option value="SUCCESS">SUCCESS</option>
                        <option value="PENDING">PENDING</option>
                        <option value="FAILED">FAILED</option>
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">From Date</label>
                      <input type="date" className="form-control" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">To Date</label>
                      <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                    </div>
                    <div className="col-12 text-end">
                      <button className="btn btn-primary me-2" onClick={handleSearch}>
                        <i className="ri-search-line me-1"></i> Search
                      </button>
                      <button className="btn btn-danger" onClick={handleReset}>
                        <i className="ri-refresh-line me-1"></i> Reset
                      </button>
                    </div>
                  </div>

                  {/* --- Table Section --- */}
                  <div className="table-responsive table-card p-2">
                    <table className="table align-middle" id="sightseeingTable">
                      <thead className="bg-soft-success bg-gradient">
                        <tr>
                          <th>Id</th>
                          <th>Booking No</th>
                          <th>Destination</th>
                          <th>Travel Date</th>
                          <th>Traveller</th>
                          <th>Booking Status</th>
                          <th>Payment Status</th>
                          <th>Amount</th>
                          <th>Ticket</th>
                          <th>Created By</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pageLoading ? (
                          <tr>
                            <td colSpan="10" className="text-center">
                              <img src="/assets/images/loader.webp" width="64px" height="64px" alt="Loading..." />
                              <p>Loading, Please wait...</p>
                            </td>
                          </tr>
                        ) : lists.length > 0 ? (
                          lists.map((v, index) => (
                            <tr key={v.sightSeeingBookingId}>
                              <td>{(pageNumber - 1) * pageSize + (index + 1)}</td>
                              <td>{v.bookingNo}</td>
                              <td>{v.city}</td>
                              <td>{moment(v.travelDate).format("DD MMM YYYY")}</td>
                              <td>{v.travellerName}</td>
                              <td>
                                <span className={`badge bg-${v.bookingStatus === 'CONFIRMED' ? 'success' : 'warning'}`}>
                                  {v.bookingStatus}
                                </span>
                              </td>
                              <td>
                                <span className={`badge bg-${v.paymentStatus === 'SUCCESS' ? 'success' : 'danger'}`}>
                                  {v.paymentStatus}
                                </span>
                              </td>
                              <td>{Math.round(v.customerPrice)} INR</td>
                              
                              <td>
                                {v.ticketSrc ? (
                                  <a href={v.ticketSrc} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-soft-success">
                                    <i className="ri-file-download-line"></i> TICKET
                                  </a>
                                ) : (
                                  <span className="text-muted">No Ticket</span>
                                )}
                              </td>
                              <td>{v.createdBy}</td>
                              <td>
                                <Link to={`/sightseeing/booking/${v.sightSeeingBookingId}`} className="btn btn-sm btn-primary">
                                  VIEW
                                </Link>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="10" className="text-center">No bookings found matching filters.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* --- Pagination Footer --- */}
                  <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                    <div className="flex-shrink-0">
                      <div className="text-muted">
                        Showing <span className="fw-semibold">{lists.length}</span> of{" "}
                        <span className="fw-semibold">{totalRecords}</span> Results
                      </div>
                    </div>
                    <ul className="pagination pagination-separated pagination-sm mb-0">
                      <li
                        className={`page-item ${rawResponse.previousPage === null ? "disabled" : ""}`}
                        onClick={GetFirstPageData}
                      >
                        <Link className="page-link">First</Link>
                      </li>
                      {renderPageNumbers}
                      <li
                        className={`page-item ${rawResponse.nextPage === null ? "disabled" : ""}`}
                        onClick={GetLastPageData}
                      >
                        <Link className="page-link">Last</Link>
                      </li>
                    </ul>
                  </div>

                </div>
              </div>
            </div>
          </div>
  );
};

export default SightSeeingBookings;